'use client'

import OptOutArbitrationContainer from 'src/pageContainers/OptOutArbitrationPage'

export default function OptOutArbitration() {
  return <OptOutArbitrationContainer />
}
